import { useEffect, useMemo, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { dateConvert, dateHoverRange } from "../../../utils/Helper";
import _ from "underscore";

export const useWorklog = ({ projectId, key, showPopup, dateFilter }) => {

    const [filterValues, setFilterValues] = useState({ date: [], expand: false });
    const [summaryData, setSummaryData] = useState({ data: [], total_hours: 0 });
    const [showDetails, setShowDetails] = useState({ visible: false, group: {}, issue_type_data: [] });
    const [loader, setLoader] = useState({ summary: false, issue_type_summary: false, details: false });
    const [worklogDetails, setWorklogDetails] = useState({
        visible: false, issue_type: "", row_data: []
    })
    const columns = [{
        key: "log_date",
        label: "Log Date",
        style: { width: "100px" },
        render: (row) => {
            return (
                <div className="py-1">{row?.log_date ? dateConvert(new Date(row?.log_date), "day-mon-year") : ""}</div>
            )
        }
    },
    {
        key: "user_display_name",
        label: "Employee",
        style: { width: "130px" },
        render: (row) => {
            return (
                <div className="py-1">{row?.user_display_name}</div>
            )
        }
    },
    {
        key: "comment",
        label: "Comment",
        style: { width: "350px", flex: 1 },
        render: (row) => {
            return (
                <div className={`py-1 ${filterValues?.expand ? "" : "text-truncate"}`} title={row?.comment}>{row?.comment}</div>
            )
        }
    },
    {
        key: "time_spent",
        label: "Hours",
        style: { width: "80px", textAlign: "right" },
        headerStyle: {paddingLeft: "20px"},
        render: (row) => {
            return (
                <div className="py-1 pe-3">{row?.time_spent ? row?.time_spent : "-"}</div>
            )
        }
    },
    ]

    useEffect(() => {
        getIssueTypeSummary();
    }, [showPopup?.group])

    useEffect(() => {
        if (key === "summary") {
            getWorklogSummary();
        } else if (key === "issue_type_summary") {
        }
    }, [key])

    const getWorklogSummary = async () => {
        try {
            setLoader((prev) => ({ ...prev, summary: true }));
            let from = "";
            let to = "";
            if (filterValues?.date?.[0] && !filterValues?.date?.[1]) {
                setFilterValues((prev) => ({ ...prev, date: [] }));
            } else if (filterValues?.date?.[0] && filterValues?.date?.[1]) {
                from = dateHoverRange(filterValues?.date?.[0]);
                to = dateHoverRange(filterValues?.date?.[1]);
            }
            const payload = {
                from_date: from,
                to_date: to,
                project_id: projectId
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTINFOWORKLOGSUMMARY"), payload);
            if (res) {
                const data = res?.body?.data?.project_info_worklog_summary;
                let sum = 0;
                _.pluck(data, "time_spent_hours").forEach(num => sum += num);
                setSummaryData((prev) => ({ ...prev, data, total_hours: parseFloat(sum?.toFixed(2)) }));
                setLoader((prev) => ({ ...prev, summary: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, summary: false }));
        }
    }

    const getIssueTypeSummary = async () => {
        try {
            setLoader((prev) => ({ ...prev, issue_type_summary: true }));
            let from = "";
            let to = "";
            if (dateFilter?.[0] && !dateFilter?.[1]) {
                setFilterValues((prev) => ({ ...prev, date: [] }));
            } else if (dateFilter?.[0] && dateFilter?.[1]) {
                from = dateHoverRange(dateFilter?.[0]);
                to = dateHoverRange(dateFilter?.[1]);
            }
            const payload = {
                from_date: from,
                to_date: to,
                project_id: projectId,
                issue_type_group_id: showPopup?.group?.issue_type_group_id || 0,
                request_user_code: showPopup?.group?.user_code || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTINFOWORKLOGISSUETYPESUMMARY"), payload);
            if (res) {
                const data = res?.body?.data?.project_info_worklog_summary;
                setShowDetails((prev) => ({ ...prev, issue_type_data: data }));
                setLoader((prev) => ({ ...prev, issue_type_summary: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, issue_type_summary: false }));
        }
    }

    const getWorklogDetails = async (issue) => {
        try {
            setLoader((prev) => ({ ...prev, details: true }));
            let from = "";
            let to = "";
            if (dateFilter?.[0] && !dateFilter?.[1]) {
                setFilterValues((prev) => ({ ...prev, date: [] }));
            } else if (dateFilter?.[0] && dateFilter?.[1]) {
                from = dateHoverRange(dateFilter?.[0]);
                to = dateHoverRange(dateFilter?.[1]);
            }
            const payload = {
                from_date: from,
                to_date: to,
                project_id: projectId,
                issue_type_id: (issue ? issue?.issue_type_id : worklogDetails?.issue_type) || 0,
                request_user_code: showPopup?.group?.user_code || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("GETPROJECTINFOWORKLOGISSUETYPEDETAILS"), payload);
            if (res) {
                const data = res?.body?.data?.project_info_worklog_summary;
                setWorklogDetails((prev) => ({ ...prev, row_data: _.sortBy(data, "log_date")?.reverse() }));
                setLoader((prev) => ({ ...prev, details: false }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, details: false }));
        }
    }

    const getIcon = (key) => {
        switch (key) {
            case "project":
                return { icon: "fa-solid fa-code-commit", color: "#3b82f6" };
            case "optimization":
                return { icon: "fa-solid fa-microchip", color: "#06b6d4" };
            case "team_support":
                return { icon: "fa-solid fa-headphones", color: "#f97316" };
            case "client_support":
                return { icon: "fa-solid fa-headphones", color: "#f97316" };
            case "leave":
                return { icon: "fa-solid fa-house", color: "#ff7e7e" };
            case "non_project_hours":
                return { icon: "fa-solid fa-circle-exclamation", color: "#6b7280" };
            case "refinement":
                return { icon: "fa-solid fa-lightbulb", color: "#eab308" };
            default:
                return { icon: "fa-solid fa-lightbulb", color: "#eab308" };
        }
    }

    return useMemo(() => ({
        summaryData, filterValues, setFilterValues, getWorklogSummary, getIcon, showDetails, setShowDetails, loader, getWorklogDetails, worklogDetails, setWorklogDetails, columns
    }), [summaryData, filterValues, setFilterValues, getWorklogSummary, getIcon, showDetails, setShowDetails, loader, getWorklogDetails, worklogDetails, setWorklogDetails, columns])
}